/**
 * 관리자 카테고리 DnD 편집기(4단 컬럼: 게시판 - 메인카테고리 - 서브카테고리 - 게시글)에서 쓰는 타입/헬퍼.
 */
export type NodeType = "board" | "main" | "sub" | "post";

export interface BoardNode {
  boardId: number;
  name: string;
  rootCategoryId?: number;
  categoryType?: string;
}

export interface CatNode {
  id: number;
  name: string;
  listOrder?: number;
}

export interface PostNode {
  id: number;
  title: string;
  listOrder?: number;
}

// dnd-kit 의 draggable/droppable id 는 "타입:숫자id" 형태로 인코딩한다.
// (카테고리 id 와 게시글 id 가 숫자로 겹칠 수 있어 타입 prefix 로 구분)
export const dndId = (type: NodeType, id: number | string): string => `${type}:${id}`;

export const parseDndId = (raw: string): { type: NodeType; id: number } => {
  const idx = raw.indexOf(":");
  return {
    type: raw.slice(0, idx) as NodeType,
    id: Number(raw.slice(idx + 1)),
  };
};
